import { call, put, takeEvery, all } from 'redux-saga/effects';

import api from 'core/utils/api';
import AuthService from '../../../core/utils/auth/auth-service';
import { actions } from './account-activation-reducer';


function* activate(action) {
  const { id, token } = action.payload[0];
  const redirect = action.payload[1];

  try {
    const res = yield call(api.patch, `/account_activations/${id}`, { user: { token } });
    AuthService.setAuthTokens(res.data.jwt, res.data.user);
    yield call(redirect);
  } catch (err) {
    yield put(actions.activateFail(err.response.data.error));
  }
}

function* watchActivate() {
  yield takeEvery(actions.activate().type, activate);
}

export default function* accountProfileSaga() {
  yield all([
    watchActivate(),
  ]);
}



// WEBPACK FOOTER //
// ./src/features/Account/AccountActivation/account-activation-saga.js